import MarkDownRenderer from '../../../../commonComponents/MarkDownRender/MarkDownRender.Component';

export const markdownContent = `
# **OpenAPI & Swagger Integration**

HawkClient provides built-in support for creating **OpenAPI (Swagger) specifications** at the **collection level**.

You can effortlessly design and manage your API definitions using **Swagger YAML**, making it easy to:
- Define endpoints, parameters, and schemas
- Maintain accurate API documentation
- Keep API design and testing in sync

With full OpenAPI support, HawkClient simplifies API documentation while staying completely offline and Git-friendly.

![OpenAPI Overview](/openAPI.png)
`;

const OpenAPIOverview = () => {
    return (
        <MarkDownRenderer
            title="OpenAPI & Swagger Integration"
            markDownText={markdownContent}
        />
    );
};

export default OpenAPIOverview;
